import { jsx, Fragment } from "react/jsx-runtime";
import { memo, useDeferredValue } from "react";
import { formatNumber } from "./formatNumber.js";
const FormattedPhoneNumber = memo(
  ({ children }) => {
    const deferred = useDeferredValue(children);
    return deferred ? /* @__PURE__ */ jsx(Fragment, { children: formatNumber(deferred) }) : null;
  }
);
FormattedPhoneNumber.displayName = "FormattedPhoneNumber";
export {
  FormattedPhoneNumber
};
//# sourceMappingURL=FormattedPhoneNumber.js.map
